exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3GCGd9u6sCDYvdLxRCjt2e{background:url(" + require("./assets/Sec-2/section2_bg.webp") + ") 20% 100%/contain no-repeat scroll}._34moKpQipcL4naPQCHn2zY{background:#e8f1f5}._1KnXjnU4Ez5yBZwK78XpvE:before{color:#4f97fb!important;font-size:2.1rem;padding-top:6px}.r296TfTiN_YsG7ILzV9Va{background:url(" + require("./assets/Sec-3/section-4_bg.jpg") + ") 100% 100%/cover no-repeat scroll}._2ksuR5m75RCLZc3HOzF4G5{font-size:2rem!important;display:flex!important;margin:0 auto!important;width:fit-content}#_2GAlz3OQlw99HNo7GoXmhb{font-size:1.3rem!important}#_2GAlz3OQlw99HNo7GoXmhb div,._1ujPg-eU8IBVAd_ylQpd-G{color:#000!important;font-family:Droid Arabic Kufi,Lato,Helvetica Neue,Arial,Helvetica,sans-serif!important;line-height:1.7}", ""]);

// exports
exports.locals = {
	"exportSection": "_3GCGd9u6sCDYvdLxRCjt2e",
	"section3": "_34moKpQipcL4naPQCHn2zY",
	"listItem": "_1KnXjnU4Ez5yBZwK78XpvE",
	"section4": "r296TfTiN_YsG7ILzV9Va",
	"CTAButton": "_2ksuR5m75RCLZc3HOzF4G5",
	"accordion": "_2GAlz3OQlw99HNo7GoXmhb",
	"fromField": "_1ujPg-eU8IBVAd_ylQpd-G"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/containers/StaticPage/LynksExport/index.css
// module id = ./node_modules/css-loader/index.js?{"modules":true}!./app/containers/StaticPage/LynksExport/index.css
// module chunks = 40